import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamQuestionSchema } from './schemas';

export const LEGACY_EXAM_QUESTION_FIELDS = describeFields(LegacyExamQuestionSchema, {
  examCode: {},
  id: {},
  creationDatetime: {},
  editDatetime: {},
  labelParts: {},
  maxMark: {},
  type: {},
  topicCodes: { widget: FieldWidget.Select },
  active: { widget: FieldWidget.Text },
  analytics: {},
  criteria: {},
  guides: {},
});
